<template>
  <div class="card-form">
    <div style="margin-top:10px;">
      <page-header
        @reset="reset"
        slot="header"
        @submit="handleSubmit"
        ref="header"
      />
    </div>
    <page-main :table-data="table" :isShow="isShow" @submit="reload" />
    <js-pagination
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      :pageSizes="pageSizes"
      size="sm"
      align="right"
      @change="handlePaginationChange"
      v-if="isShow"
    />
  </div>
</template>

<script>
export default {
  name: 'digitalExhibitionHall-design-elementsInfo',
  components: {
    PageHeader: () => import('./components/header/index'),
    PageMain: () => import('./components/body/index')
  },
  data() {
    return {
      table: [],
      isShow: true,
      page: {
        curPage: 1,
        pageSize: 8,
        pageTotal: 0
      },
      pageSizes: [8, 20, 40, 80, 100]
    }
  },
  methods: {
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 8,
        pageTotal: 0
      }
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 重载表格数据
    reload() {
      this.$refs.header.query()
    },
    // 加载表格数据
    handleSubmit(form) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$api
        .listDesignElementsInfoApi({
          ...form,
          ...this.page
        })
        .then((res) => {
          loading.close()
          this.page.pageTotal = res.body.count
          this.table = res.body.data
          if (this.table.length > 0) {
            this.isShow = true
          } else {
            this.isShow = false
          }
        })
        .catch(() => {
          loading.close()
        })
    }
  }
}
</script>
<style lang="scss"></style>
